import React from 'react';
import MessagingApp from './MessagingApp';

function MessagingWrapper() {
  return <MessagingApp />;
}

export default MessagingWrapper;
